<script>
import CollectionRoute from '@/components/CollectionRoute' // eslint-disable-line no-unused-vars

export default {
  name: 'Requisitions',
  render (h) {
    return <CollectionRoute/>
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('requisitions/get')
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('requisitions/get')
    next()
  }
}
</script>
